import './App.css'
import Configurator from "./components/Configurator"
import { Image, Nav, Navbar } from "react-bootstrap"
import React, { useEffect, useLayoutEffect, useState } from "react"
import logo2 from "../src/assets/logo.PNG"
import faceIcon from "../src/assets/homeImages/facebook.png"
import { Link, Route, Switch, withRouter } from "react-router-dom"
import Home from "./components/Home/Home"
import Drawings from "./components/Drawings/Drawings"
import { tabs } from "./variables.js"
import Rules from "./components/Rules/Rules"
import Contact from "./components/Contact/Contact"
import Gallery from "./components/Gallery/Gallery"
import Topbar from "./components/Topbar/Topbar"

function App({history}) {

    const offsetTop = document.getElementById("root").getBoundingClientRect().top
    const initHeight = Math.ceil(window.innerHeight - offsetTop)
    const initTopBarHeight = document.getElementById("topBar") ? document.getElementById("topBar").clientHeight : 0

    const [height, setHeight] = useState(initHeight)
    const [contentHeight, setContentHeight] = useState()
    const [topBarHeight, setTopBarHeight] = useState(initTopBarHeight)

    const resizeHandler = () => {
        let boundingRect = document.getElementById("root").getBoundingClientRect()
        setHeight(Math.ceil(window.innerHeight - boundingRect.top))
        setTopBarHeight(document.getElementById("topBar") ? document.getElementById("topBar").clientHeight : 0)
    }

    const calculateContainerHeight = () => {
        const topBarHeight = document.getElementById("topBar") ? document.getElementById("topBar").clientHeight : 0
        const contentHeight = height - topBarHeight

        setContentHeight(contentHeight)
        setTopBarHeight(topBarHeight)

    }

    useEffect(() => {
        let sapUiBody = document.getElementsByClassName("sapUiBody")
        if (sapUiBody.length !== 0) sapUiBody[0].style.overflow = "hidden"
        window.addEventListener("resize", resizeHandler)
        window.addEventListener("shown.bs.collapse", resizeHandler)

        return () => window.removeEventListener("resize", resizeHandler)
    }, [])

    useEffect(() => {
        resizeHandler()
    }, [offsetTop, initTopBarHeight])

    useLayoutEffect(() => {
        calculateContainerHeight()
    })

    return (
        <div>
            <Topbar/>
            <Switch>
                <Route exact path="/" render={() => <Home/>}/>
                <Route path="/configurator" render={() =>
                    <Configurator contentHeight={contentHeight}/>}/>
                <Route path="/drawings" render={() => <Drawings/>}/>
                <Route path="/rules" component={Rules}/>
                <Route path="/gallery" component={Gallery}/>
                <Route path="/contact" component={Contact}/>
            </Switch>
            <p className={`copyrights mt-auto`}>Copyright © 2021 Custom Map Holder. All rights reserved.</p>
        </div>
    );
}

export default withRouter(App)
